import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { customElement, property, query } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement, TemplateResult } from 'lit'
import { RemoveBasketRequest } from 'components/ordering/multiple-baskets/basket-api/remove-basket.js'
import { BASKET_API, BasketApi } from 'components/ordering/multiple-baskets/basket-api/basket-api.js'
import { CSEModal } from '@cloudsuite/mosaic-elements'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { WINDOW_LOCATION, WindowLocation } from '@cloudsuite/mosaic-shared/scripts/window-location.js'


initializeIconsByRole({
  'csc-basket-delete-button.delete': { name: 'trash', style: 'regular' },
})
@customElement('csc-basket-delete-button')
export class CSCBasketDeleteButton extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ attribute: 'basket-id' })
  basketId!: string

  @property({ attribute: 'ordering-endpoint' })
  orderingEndpoint = ''

  @inject(BASKET_API)
  private basketApi!: BasketApi

  @inject(WINDOW_LOCATION)
  private windowLocation!: WindowLocation

  @query('cse-modal')
  modal!: CSEModal

  private handleConfirmClick = async () => {
    const request = new RemoveBasketRequest(this.orderingEndpoint, this.basketId)
    await this.basketApi.removeBasket(request)
    this.windowLocation.reload()
  }

  override render(): TemplateResult {
    return html`
      <div class="basket-delete-button">
        <cse-icon-button
          variant="secondary"
          @click="${() => this.modal.open()}">
          <cse-icon icon-role="csc-basket-delete-button.delete"></cse-icon>
        </cse-icon-button>
      </div>
      <cse-modal variant="error">
        <div slot="header">
          ${t('modal_header', { ns: 'csc-basket-delete-button', default: 'Remove basket' })}
        </div>
        <cse-icon
          icon-role="csc-basket-delete-button.delete"
          slot="icon"
          size="xl"
        ></cse-icon>
        <cse-text class="description">
          ${t('warning_text', { ns: 'csc-basket-delete-button', default: 'Please note, you are about to delete your basket. This cannot be undone. Are you sure you want to continue?' })}
        </cse-text>
        <cse-button
          slot="footer"
          fit="fill"
          id="confirm"
          type="button"
          @click="${this.handleConfirmClick}">
          ${t('confirm_button', { ns: 'csc-basket-delete-button', default: 'Yes, delete' })}
        </cse-button>
        <cse-button
          slot="footer"
          fit="fill"
          id="cancel"
          type="button"
          @click="${() => this.modal.close()}">
          ${t('cancel_button', { ns: 'csc-basket-delete-button', default: 'No, cancel' })}
        </cse-button>
      </cse-modal>
    `
  }
}
